import { ERROR_MESSAGE_TYPE_DEFAULT } from "../../components/ErrorMessages/ErrorMessages";
import commonApiRequest from "../../utils/commonApiRequest";
import { getProfile } from "./profile";
import { ps } from "../../components/Application/Application";
import { setData } from "../actions/auth";
import store from "../index";
import {
	API_NSP_AUTH,
	API_NSP_OPERATION_EXTEND,
	API_NSP_OPERATION_LOGIN,
	API_NSP_OPERATION_LOGOUT,
	API_NSP_OPERATION_TOKEN_EXCHANGE,
	API_NSP_OPERATION_VERIFY,
	getApiUrl
} from "../../config/api";
import {
	PS_EVENT_ACCESS_DENIED,
	PS_EVENT_ACCESS_GRANTED,
	PS_EVENT_SESSION_END,
	SYSTEM_ERROR_CNX,
	SYSTEM_ERROR_INV
} from "../../config/common";
import {
	REQUEST_METHOD,
	isDate,
	isNumber,
	isObject,
	isStringOfLength,
} from "@pheaa/channels-component-library";

const handleAuthErrors = ({ body, headers, status }) => {
	if (isNumber(status)) {
		store.dispatch(setData({ systemErrors: [{ code: status, type: ERROR_MESSAGE_TYPE_DEFAULT }] }));
	} else {
		store.dispatch(setData({ systemErrors: [{ code: SYSTEM_ERROR_INV, type: ERROR_MESSAGE_TYPE_DEFAULT }] }));
		throw new Error("Expected HTTP Error Response Code Not Received.");
	}
};

const handleAuthFailures = (error, additionalData = {}) => {
	if (isObject(error) && isStringOfLength(error.message) && error.message.toLowerCase() === "failed to fetch") {
		store.dispatch(setData({ systemErrors: [{ code: SYSTEM_ERROR_CNX, type: ERROR_MESSAGE_TYPE_DEFAULT }], ...additionalData }));
	} else {
		store.dispatch(setData({ systemErrors: [{ code: SYSTEM_ERROR_INV, type: ERROR_MESSAGE_TYPE_DEFAULT }], ...additionalData }));
	}
};

const handleAuthVerification = ({ body, headers, status }, additionalData = {}) => {
	const now = new Date(body.now);
	let tokenExpiry = now;
	let tokenLastVerifiedAt = new Date(now).getTime();

	if (isNumber(body.accessExpiresIn) && isDate(now)) {
		tokenExpiry.setSeconds(tokenExpiry.getSeconds() + body.accessExpiresIn);
		store.dispatch(setData({ ...body, authAccessExpiresAt: tokenExpiry.getTime(), tokenLastVerifiedAt, ...additionalData }));
	} else {
		store.dispatch(setData({ systemErrors: [{ code: SYSTEM_ERROR_INV, type: ERROR_MESSAGE_TYPE_DEFAULT }], ...additionalData }));
		console.warn("API Response 'accessExpiresIn' or 'now' property value Invalid.");
	}
};

export const endSession = redirectUrl => (dispatch, getState) => {
	commonApiRequest({ nsp: API_NSP_AUTH, operation: API_NSP_OPERATION_LOGOUT }, {
		alwaysCallback: () => {
			// Intentionally not dispatching event to setData isPendingSessionEnd to false;
			// dispatch(setData({ isPendingSessionEnd: false }));
			ps.publish(PS_EVENT_SESSION_END, { redirectUrl });
		},
		beforeCallback: () => { dispatch(setData({ isPendingSessionEnd: true })); },
		method: REQUEST_METHOD.DELETE
	});
};

export const extendSession = () => (dispatch, getState) => {
	commonApiRequest({ nsp: API_NSP_AUTH, operation: API_NSP_OPERATION_EXTEND }, {
		alwaysCallback: () => { dispatch(setData({ isPendingSessionExtension: false })); },
		beforeCallback: () => { dispatch(setData({ systemErrors: [], isPendingSessionExtension: true })); },
		errorCallback: ({ body, headers, status }) => {
			try {
				handleAuthErrors({ body, headers, status });
			} catch (e) {
				console.error(e);
			}
		},
		failCallback: error => {
			try {
				handleAuthFailures(error);
			} catch (e) {
				console.error(e);
			}
		},
		method: REQUEST_METHOD.PUT,
		successCallback: ({ body, headers, status }) => {
			handleAuthVerification({ body, headers, status });
		}
	});
};

export const exchangeTokens = (getProfileOnSuccess = false, getInboxOnSuccess = false) => (dispatch, getState) => {
	return commonApiRequest({ nsp: API_NSP_AUTH, operation: API_NSP_OPERATION_TOKEN_EXCHANGE }, {
		successCallback: ({ body, headers, status }) => {
			handleAuthVerification({ body, headers, status }, { isAuthenticated: true, tokenExchangeId: null });
			ps.publish(PS_EVENT_ACCESS_GRANTED);
			getProfileOnSuccess && dispatch(getProfile(getInboxOnSuccess));
		}
	});
};

export const verifyTokens = (getProfileOnSuccess = false, getInboxOnSuccess = false) => (dispatch, getState) => {
	const handleAccessDenied = () => {
		const publishEventData = {};
		window.location.pathname !== "/" && (publishEventData.nextEvent = window.location.pathname);
		dispatch(setData({ isAuthenticated: false, isPendingTokenVerification: false }));
		ps.publish(PS_EVENT_ACCESS_DENIED, publishEventData);
	};

	const handleLoginRedirect = () => {
		const url = getApiUrl(API_NSP_AUTH, API_NSP_OPERATION_LOGIN);
		dispatch(setData({ isAuthenticated: false, isPendingTokenVerification: true }));
		window.location = url;
	};

	return commonApiRequest({ nsp: API_NSP_AUTH, operation: API_NSP_OPERATION_VERIFY }, {
		beforeCallback: () => {
			dispatch(setData({ isPendingTokenVerification: true }));
		},
		errorCallback: () => {
			getState().common.isAppInitialized ? handleAccessDenied() : handleLoginRedirect();
		},
		failCallback: () => {
			getState().common.isAppInitialized ? handleAccessDenied() : handleLoginRedirect();
		},
		successCallback: ({ body, headers, status }) => {
			handleAuthVerification({ body, headers, status }, { isAuthenticated: true, isPendingTokenVerification: false, tokenExchangeId: null });
			ps.publish(PS_EVENT_ACCESS_GRANTED);
			getProfileOnSuccess && dispatch(getProfile(getInboxOnSuccess));
		}
	});
};